import React from 'react';
import DashboardContainer from '../orders-dashboard/DashboardContainer';

const OrdersDashboard = props => (
  <React.Fragment>
    <DashboardContainer {...props} />
  </React.Fragment>
);
export default OrdersDashboard;
